/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLandingPageFunnelSourceData
 */
export interface GoogleLandingPageFunnelSourceData {
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    completeness?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    truncated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    thresholded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    dataLossFromOtherRow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    sampled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    publishedRowCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    fetchedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleLandingPageFunnelSourceData
     */
    publishedAt?: Date;
}

/**
 * Check if a given object implements the GoogleLandingPageFunnelSourceData interface.
 */
export function instanceOfGoogleLandingPageFunnelSourceData(value: object): value is GoogleLandingPageFunnelSourceData {
    return true;
}

export function GoogleLandingPageFunnelSourceDataFromJSON(json: any): GoogleLandingPageFunnelSourceData {
    return GoogleLandingPageFunnelSourceDataFromJSONTyped(json, false);
}

export function GoogleLandingPageFunnelSourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageFunnelSourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'completeness': json['completeness'] == null ? undefined : json['completeness'],
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
        'thresholded': json['thresholded'] == null ? undefined : json['thresholded'],
        'dataLossFromOtherRow': json['dataLossFromOtherRow'] == null ? undefined : json['dataLossFromOtherRow'],
        'sampled': json['sampled'] == null ? undefined : json['sampled'],
        'publishedRowCount': json['publishedRowCount'] == null ? undefined : json['publishedRowCount'],
        'fetchedAt': json['fetchedAt'] == null ? undefined : (new Date(json['fetchedAt'])),
        'publishedAt': json['publishedAt'] == null ? undefined : (new Date(json['publishedAt'])),
    };
}

export function GoogleLandingPageFunnelSourceDataToJSON(json: any): GoogleLandingPageFunnelSourceData {
    return GoogleLandingPageFunnelSourceDataToJSONTyped(json, false);
}

export function GoogleLandingPageFunnelSourceDataToJSONTyped(value?: GoogleLandingPageFunnelSourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'completeness': value['completeness'],
        'truncated': value['truncated'],
        'thresholded': value['thresholded'],
        'dataLossFromOtherRow': value['dataLossFromOtherRow'],
        'sampled': value['sampled'],
        'publishedRowCount': value['publishedRowCount'],
        'fetchedAt': value['fetchedAt'] == null ? value['fetchedAt'] : value['fetchedAt'].toISOString(),
        'publishedAt': value['publishedAt'] == null ? value['publishedAt'] : value['publishedAt'].toISOString(),
    };
}

